import { render, staticRenderFns } from "./RedefinePassword.vue?vue&type=template&id=95d1f70a"
import script from "./RedefinePassword.vue?vue&type=script&lang=js"
export * from "./RedefinePassword.vue?vue&type=script&lang=js"
import style0 from "./RedefinePassword.vue?vue&type=style&index=0&id=95d1f70a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports